{
  "home": {
    "heroBadge": "英國值得信賴嘅卡牌拍賣行",
    "heroTitleLine1": "英國頂尖嘅",
    "heroTitleLine2": "集換卡交易平台",
    "heroSubtitle": "透過英國各地嘅安全實時拍賣,買賣經鑑定認證嘅集換卡,包括寶可夢、One Piece、高達、體育卡、Magic: The Gathering、遊戲王、龍珠超、迪士尼Lorcana等等。",
    "browseCta": "瀏覽即時拍賣",
    "sellCta": "開始寄賣",
    "searchPlaceholder": "搜尋卡牌、公仔、服飾及更多…",
    "searchButton": "搜尋",
    "popularLabel": "熱門",
    "liveNow": "即時進行中",
    "endingTodayCount": "今日有 {count} 場拍賣結束",
    "highestBid": "最高出價",
    "endsIn": "距離結束",
    "watchingCount": "{count} 人關注緊",
    "viewLive": "查看即時拍賣",
    "categoriesEyebrow": "按分類瀏覽",
    "categoriesTitle": "搜羅你鍾意嘅卡牌",
    "viewAll": "查看全部",
    "exploreCta": "探索",
    "statCardsListed": "已上架卡牌",
    "statCollectors": "收藏家",
    "statVolume": "拍賣成交額",
    "statRating": "賣家評分",
    "statSecurePayments": "安全付款",
    "statSecurePaymentsDescription": "由 Stripe 提供安全付款處理。",
    "statNoRatingsYet": "暫時未有評分",
    "statNewMarketplace": "全新平台",
    "statReviewsCount": "{count, plural, other {# 個評價}}",
    "heroBadgeV2": "卡牌 • 收藏品 • 時尚",
    "heroV2Line1": "出價更多，收藏更多。",
    "heroV2Line2": "盡在 BidNova。",
    "heroV2Subtitle": "英國集換卡、收藏品、時尚服飾及更多的拍賣市場。",
    "browseCtaV2": "瀏覽拍賣",
    "sellCtaV2": "出售物品",
    "searchPlaceholderV2": "搜尋卡牌、公仔、服飾及更多…",
    "categoriesTitleV2": "卡牌、收藏品與時尚",
    "cat": {
      "cards": "集換卡",
      "graded": "評級卡",
      "sealed": "未開封產品",
      "collectibles": "公仔與收藏品",
      "fashion": "時尚",
      "accessories": "配件"
    },
    "catBlurb": {
      "cards": "各類遊戲單卡",
      "graded": "PSA、BGS、CGC、ACE 等",
      "sealed": "補充盒、卡包、鐵盒及卡組",
      "collectibles": "Funko Pop!、公仔、雕像",
      "fashion": "街頭服飾、波鞋、手袋",
      "accessories": "卡套、卡磚及收納"
    },
    "trust": {
      "paymentsTitle": "安全付款",
      "paymentsSub": "由 Stripe 提供",
      "shippingTitle": "可追蹤運送",
      "shippingSub": "遍及英國",
      "trustedTitle": "值得信賴的市場",
      "trustedSub": "安心買賣"
    }
  },
  "seo": {
    "trustedMarketplaceEyebrow": "值得信賴嘅英國市場",
    "introTitle": "交易全球最受歡迎嘅集換卡",
    "introBody1": "BidNova Auctions 係英國值得信賴嘅市場,專門買賣經鑑定嘅集換卡。我哋支援各大主要 TCG 同體育卡分類嘅收藏家,提供公開透明嘅競投、安全嘅 Stripe 付款同埋完善嘅買家保障。",
    "weSupportLabel": "我哋支援嘅收藏類別",
    "introBody2": "無論你收藏 PSA、BGS 定 CGC 鑑定卡,定係搵緊罕見裸卡,BidNova 都提供安全嘅市場、買家保障同值得信賴嘅賣家。",
    "categoriesEyebrow": "按分類瀏覽",
    "categoriesTitle": "集換卡分類",
    "trustEyebrow": "收藏家點解揀 BidNova",
    "trustTitle": "放心競投",
    "trustSecureTitle": "100% 安全付款",
    "trustSecureBody": "由 Stripe 提供支援,完全符合 PCI-DSS 標準並支援 3-D Secure。",
    "trustVerifiedTitle": "已驗證賣家",
    "trustVerifiedBody": "每項刊登都經過身份驗證同持續防欺詐保障。",
    "trustProtectionTitle": "買家保障",
    "trustProtectionBody": "公開透明嘅競投、安全結賬,未能送達可獲退款。",
    "trustGradingTitle": "專業鑑定",
    "trustGradingBody": "支援 PSA、BGS、CGC、SGC、ACE、PG 同 TAG 鑑定卡 — PSA、BGS、CGC 同 SGC 更設自動證書驗證。",
    "sellerCtaEyebrow": "賣家專區",
    "sellerCtaTitle": "放心寄賣你嘅集換卡",
    "sellerCtaBody": "透過安全嘅限時拍賣接觸全英國嘅收藏家。成功售出先收取劃一 8% 佣金 — 無上架費、無月費、無訂閱費。實時競投、安全撥款,由上架到送達全程可追蹤。",
    "sellerCtaButton": "即刻開始寄賣",
    "collectionsEyebrow": "支援嘅收藏類別",
    "collectionsTitle": "涵蓋各大主要 TCG 同體育卡系列",
    "faqEyebrow": "常見問題",
    "faqTitle": "常見問題解答"
  },
  "faq": {
    "q1": "網上集換卡拍賣點運作?",
    "a1": "賣家會為卡牌設定起標價、拍賣時間同可選嘅「即時購買」。已註冊買家可實時出價,拍賣倒數結束後由最高出價者得標,並透過 Stripe 安全付款 — 賣家其後會以可追蹤方式寄出卡牌,全程受買家保障覆蓋。",
    "q2": "可唔可以賣寶可夢卡?",
    "a2": "可以。寶可夢係我哋最大嘅分類。你可以上架裸卡或經 PSA、BGS、CGC、SGC、ACE、PG 或 TAG 鑑定嘅卡牌 — 單張或密封產品,由復古 Base Set 到現代嘅 Scarlet & Violet 都得。",
    "q3": "可唔可以賣 One Piece 卡?",
    "a3": "可以。BidNova 支援全套 One Piece Card Game — 由 Romance Dawn 同 Paramount War 開始,包括漫畫稀有卡、alt art 同已鑑定卡。",
    "q4": "可唔可以拍賣體育卡?",
    "a4": "可以。足球、籃球、棒球、F1、UFC 同其他體育卡都支援 — 包括 Topps、Panini Prizm、Select、Donruss 同 Bowman。",
    "q5": "支援邊啲鑑定公司?",
    "a5": "BidNova 接受由 PSA、BGS、CGC、SGC、ACE、PG 同 TAG 鑑定嘅卡牌。PSA、BGS、CGC 同 SGC 嘅證書編號會自動驗證;ACE、PG 同 TAG 卡牌則可手動輸入資料上架。",
    "q6": "買家點樣受到保障?",
    "a6": "每筆交易都經 Stripe 處理並支援 3-D Secure。賣家經身份驗證,刊登受審核,買家如遇未能送達、損毀或描述不符,可提出爭議並根據買家保障政策獲得退款。",
    "q7": "喺 BidNova 寄賣需要幾多費用?",
    "a7": "BidNova 只喺成功售出時收取劃一 8% 佣金,無月費、無訂閱費、無上架費。"
  },
  "browse": {
    "eyebrow": "市場",
    "defaultH1": "即時拍賣",
    "categoryH1": "{category} 卡牌拍賣",
    "defaultIntro": "瀏覽 BidNova Auctions 上所有即時集換卡拍賣 — 英國值得信賴嘅市場,專營經鑑定嘅寶可夢、One Piece、遊戲王、龍珠、Magic: The Gathering 同體育卡。所有刊登以英鎊標價,受 Stripe 安全付款保障同買家保障保證覆蓋。可按「即時購買」、鑑定公司(PSA、BGS、CGC、ACE)、價錢同剩餘時間篩選,亦可用 AI 智能搜尋描述你想搵嘅嘢。",
    "categoryIntro": "BidNova Auctions 上 {category} 集換卡嘅英國即時拍賣。以英鎊標價,受 Stripe 安全付款保障同買家保障保證覆蓋。可按「即時購買」、鑑定公司(PSA、BGS、CGC、ACE)、價錢同剩餘時間篩選。",
    "allCategories": "所有分類",
    "marketTrends": "市場趨勢",
    "sellACard": "寄賣卡牌",
    "smartSearchPlaceholder": "試吓輸入:「£500 以下嘅 PSA 10 Charizard」或「日版 One Piece 漫畫稀有卡」",
    "smartSearchButton": "AI 智能搜尋",
    "smartSearchClear": "清除",
    "smartSearchAiApplied": "已套用智能搜尋",
    "smartSearchKeywordApplied": "已套用關鍵字搜尋",
    "smartSearchFailed": "智能搜尋失敗",
    "purchaseMethodPlaceholder": "購買方式",
    "purchaseAll": "全部刊登",
    "purchaseAuctionOnly": "只限拍賣",
    "purchaseBuyNow": "設有即時購買",
    "purchaseAuctionPlusBin": "拍賣 + 即時購買",
    "sortPlaceholder": "排序",
    "sortEndingSoon": "即將結束",
    "sortNewlyListed": "最新上架",
    "sortCurrentBidHigh": "目前出價:由高至低",
    "sortBinLow": "即時購買價:由低至高",
    "sortBinHigh": "即時購買價:由高至低",
    "productTypePlaceholder": "產品類型",
    "anyProductType": "任何產品類型",
    "accessoryCategoryPlaceholder": "配件分類",
    "anyAccessory": "任何配件",
    "cardTypePlaceholder": "卡牌類型",
    "anyCardType": "任何卡牌類型",
    "graderPlaceholder": "鑑定公司",
    "anyGrader": "任何鑑定公司",
    "gradePlaceholder": "評級",
    "anyGrade": "任何評級",
    "brandPlaceholder": "品牌",
    "anyBrand": "任何品牌",
    "conditionPlaceholder": "狀況",
    "anyCondition": "任何狀況",
    "gamePlaceholder": "適用遊戲",
    "anyGame": "任何遊戲",
    "productLinePlaceholder": "產品系列 / 套裝",
    "anySetLine": "任何系列 / 套裝",
    "tcgGamePlaceholder": "遊戲",
    "rarityPlaceholder": "稀有度",
    "anyRarity": "任何稀有度",
    "languagePlaceholder": "語言",
    "anyLanguage": "任何語言",
    "finishPlaceholder": "卡面處理",
    "anyFinish": "任何卡面處理",
    "editionPlaceholder": "版本",
    "anyEdition": "任何版本",
    "cardSetPlaceholder": "卡套/系列…",
    "autographedLabel": "簽名版",
    "serialLabel": "編號版",
    "trustLabel": "信譽",
    "trustVerifiedChip": "已驗證",
    "trustPartnerChip": "官方夥伴",
    "trustFeaturedChip": "精選商店",
    "activeFiltersLabel": "目前篩選:",
    "removeGameFilter": "遊戲",
    "removeRarityFilter": "稀有度",
    "removeAutographedFilter": "簽名版",
    "removeSerialFilter": "編號版",
    "removeVerifiedFilter": "已驗證賣家",
    "removePartnerFilter": "官方夥伴",
    "removeFeaturedFilter": "精選商店",
    "removeProductFilter": "產品",
    "removeAccessoryFilter": "配件",
    "clearAll": "清除全部",
    "othersOption": "其他",
    "loadError": "無法載入即時拍賣。",
    "noneMatch": "目前沒有符合篩選條件的即時拍賣——請嘗試放寬條件，或稍後再查看，新上架商品會於一整天陸續推出。",
    "howBiddingWorksTitle": "競投運作方式",
    "howBiddingWorksBody": "BidNova 上所有拍賣均以英鎊（GBP）計價，並清楚顯示起標價、目前出價及倒數截止時間。您可以按下一個有效加價幅度或以上出價，如被超越出價，我們會即時通知您以便回應。部分商品亦提供「立即購買」價格，可即時購買。若拍賣在最後幾分鐘出現出價活動，系統會自動延長時間，確保沒有人可在最後一刻「狙擊」出價。",
    "biddingPoint1": "透明競投——查看每一個出價、出價人數及剩餘時間。",
    "biddingPoint2": "自動防狙擊延長機制，保障公平競爭。",
    "biddingPoint3": "得標者可透過 Stripe 以信用卡、Apple Pay 或 Google Pay 安全結帳。",
    "biddingPoint4": "賣家附追蹤編號寄出；款項於您確認收貨後才會發放。",
    "buyerProtectionTitle": "買家保障與賣家信任",
    "buyerProtectionBody": "BidNova Auctions 是於英國註冊、完全符合 GDPR 規範的市場平台。款項由 Stripe 處理，並會保留至您確認卡片與描述相符為止。賣家均經過驗證、擁有公開評級，並受我們的賣家協議約束——如有問題，另設正式爭議處理程序。",
    "protectionPoint1": "Stripe 安全託管式付款——款項僅於確認收貨後發放。",
    "protectionPoint2": "已驗證賣家，擁有公開評級及出貨追蹤。",
    "protectionPoint3": "為損壞、遺失或描述不符的卡片提供正式爭議解決機制。",
    "protectionPoint4": "英國註冊平台，以英鎊定價，受英格蘭及威爾斯法律管轄。"
  },
  "seller": {
    "loading": "載入中…",
    "loadingListings": "載入刊登中…",
    "profileUnavailableTitle": "賣家檔案未能查看",
    "profileUnavailableBody": "呢位賣家仲未公開個人檔案。",
    "browseAllAuctions": "瀏覽所有拍賣",
    "website": "網站",
    "noReviewsYet": "暫時未有評價",
    "reviewCount": "{count, plural, other {(# 個評價)}}",
    "positivePct": "{pct}% 正面評價",
    "completedSalesCount": "{count, plural, other {# 宗完成交易}}",
    "memberSince": "加入日期:{date}",
    "statTotalAuctions": "拍賣總數",
    "statTotalSales": "銷售總數",
    "statSuccessfulSales": "成功銷售",
    "statAverageFeedback": "平均評價",
    "statPositiveFeedback": "正面評價",
    "statVerification": "驗證狀態",
    "verified": "已驗證",
    "community": "社群賣家",
    "featuredProducts": "精選產品",
    "activeAuctions": "進行中拍賣",
    "noActiveListings": "呢位賣家暫時無進行中嘅刊登。",
    "recentlyEnded": "最近結束",
    "recentReviews": "最新評價",
    "somethingWentWrong": "發生咗啲問題",
    "tryAgain": "再試一次",
    "notFoundTitle": "搵唔到呢位賣家",
    "returnHome": "返回首頁",
    "loadingReviews": "載入評價中…",
    "reviewsCouldNotLoad": "未能載入評價。",
    "noReviewsBody": "呢位賣家暫時未有評價。",
    "loadMoreReviews": "載入更多評價",
    "loadingMore": "載入中…",
    "anonymousBuyer": "BidNova Auctions 買家",
    "noWrittenComment": "無留下文字評語",
    "reported": "已舉報",
    "signInToReport": "登入後即可舉報呢個評價",
    "report": "舉報",
    "reportThisReview": "舉報呢個評價",
    "reportDialogTitle": "舉報呢個評價",
    "reportDialogDescription": "話俾我哋審核團隊知呢個評價違反邊項政策。你嘅舉報屬保密,並由 BidNova Auctions 團隊審核。",
    "reportReasonLabel": "原因",
    "reportPlaceholder": "例如:包含個人資料、垃圾內容、辱罵性字眼…",
    "reportTooShort": "最少需要 {min} 個字",
    "reportLooksGood": "睇落冇問題",
    "cancel": "取消",
    "submitReport": "提交舉報",
    "reportSubmitted": "舉報已提交,多謝你嘅提報。",
    "reportMinChars": "請輸入最少 {min} 個字",
    "reportTooLong": "原因太長",
    "reportSubmitFailed": "未能提交舉報",
    "loadMoreFailed": "未能載入更多評價"
  },
  "hoverCard": {
    "fallbackName": "賣家",
    "successfulSales": "成功銷售",
    "positiveFeedback": "正面評價",
    "memberSince": "加入日期",
    "rating": "評分",
    "viewProfile": "查看檔案"
  },
  "card": {
    "priceHistory": "價格走勢(180 日)",
    "populationReport": "存世量報告",
    "catalogEyebrow": "卡牌目錄",
    "loading": "載入中…",
    "notFound": "搵唔到呢張卡。"
  },
  "trends": {
    "title": "市場趨勢",
    "subtitle": "數據只來自 BidNova 真實成交紀錄,僅供參考,並非估值。",
    "trendingCards": "熱門卡牌",
    "categoryActivity": "分類活躍度",
    "unknownSet": "未知系列",
    "salesCount": "{count} 宗成交",
    "averagePrefix": "平均 {price}",
    "noTrendData": "呢個時段暫時未有趨勢數據。隨住 BidNova 真實成交累積,趨勢就會出現。",
    "noActivityData": "呢個時段暫時未有活動數據。",
    "notFound": "搵唔到內容。"
  },
  "accessories": {
    "eyebrow": "配件",
    "breadcrumbHome": "首頁",
    "breadcrumbAuctions": "拍賣",
    "breadcrumbAccessories": "配件",
    "relatedCategories": "相關配件分類",
    "allAccessories": "所有配件",
    "noListingsBody": "暫時未有進行中嘅{category}。每日都有新刊登上架 — 瀏覽{link}或稍後再查看。",
    "allAccessoryListings": "所有配件刊登",
    "couldNotLoad": "未能載入呢啲刊登。",
    "whyBuyTitle": "點解喺 BidNova 買配件",
    "whyBuyBody": "BidNova 係英國註冊嘅市場。每件配件都由已驗證賣家出售,擁有公開評分,以英鎊標價並透過 Stripe 付款。喺你確認訂單如描述送達之前,款項會被暫扣。",
    "whyBuyPoint1": "Stripe 安全付款,附有買家保障。",
    "whyBuyPoint2": "已驗證嘅英國賣家,擁有公開評分同爭議處理機制。",
    "whyBuyPoint3": "以英鎊標價 — 無隱藏兌換費用。",
    "sellingTitle": "想寄賣配件?",
    "sellingBody": "獲批准嘅賣家可以喺同一個後台,一齊上架配件、單卡同密封產品。配件毋須填寫鑑定欄位 — 只需加相片、狀況同起標價。",
    "listAnAccessory": "上架配件"
  },
  "auctionDetail": {
    "notFoundTitle": "搵唔到呢個拍賣",
    "notFoundBody": "呢個網址好似唔啱 — 不如去瀏覽即時拍賣。"
  },
  "sell": {
    "stripeGateTitle": "完成 Stripe 帳戶設定先可以上架",
    "stripeGateBody": "BidNova Auctions 透過 Stripe Connect 俾賣家撥款。你需要一個已啟用收款同撥款功能嘅 Stripe Express 帳戶,先可以刊登拍賣。只需要幾分鐘就搞掂。",
    "detailsSubmitted": "已提交資料",
    "chargesEnabled": "已啟用收款",
    "payoutsEnabled": "已啟用撥款",
    "continueOnboarding": "繼續 Stripe 帳戶設定",
    "startOnboarding": "開始 Stripe 帳戶設定",
    "stripeStatusUpdated": "Stripe 狀態已更新"
  },
  "cookieConsent": {
    "ariaLabel": "Cookie 同意設定",
    "heading": "Cookie 與私隱",
    "body": "我們使用嚴格必要的 Cookie 以維持網站運作（登入認證、安全性及結帳）。經您同意後，我們亦會使用可選的分析及行銷 Cookie 以改善拍賣體驗並提供個人化優惠。您可隨時於頁尾更改設定。",
    "readPolicy": "閱讀我們的 Cookie 政策",
    "necessaryTitle": "嚴格必要",
    "necessaryBody": "一律啟用——登入、安全性及結帳所必需。",
    "analyticsTitle": "分析",
    "analyticsBody": "彙整使用數據以改善平台。",
    "marketingTitle": "行銷",
    "marketingBody": "個人化優惠並衡量宣傳活動成效。",
    "acceptAll": "全部接受",
    "savePreferences": "儲存偏好設定",
    "customise": "自訂",
    "rejectNonEssential": "拒絕非必要項目"
  },
  "stats": {
    "cardsListed": "上架卡牌",
    "cardsListedDesc": "進行中及已完成拍賣的卡牌總數。",
    "collectors": "收藏家",
    "collectorsDesc": "在 BidNova 買賣的註冊收藏家。",
    "auctionVolume": "成交金額",
    "auctionVolumeDesc": "所有成功完成拍賣的總成交價值。",
    "sellerRating": "賣家評分",
    "sellerRatingDesc": "已驗證買家給予的平均評分。",
    "reviewCount": "{count, plural, other {# 則評價}}",
    "newMarketplace": "全新平台",
    "noRatings": "尚未有評分",
    "securePayments": "安全付款",
    "securePaymentsDesc": "由 Stripe 安全處理付款。"
  }
}
